import { QueryType } from './types'
declare const firebase: any

export const searchActresses = async (query: QueryType) => {
  try {
    const searchActresses = firebase.app().functions('asia-northeast1').httpsCallable('searchActresses')
    const response = await searchActresses(query)
    return response.data.sort((a: any, b: any) => {
      if (a.rank > b.rank) return 1
      if (b.rank > a.rank) return -1
      else return 0
    })
  } catch {
    return 0
  }
}

const dummyActresses = [
  {
    birthday: "1992-11-12",
    bust: "83",
    cup: "E",
    height: null,
    waist: '80',
    hip: "82",
    hobby: null,
    id: "1011199",
    rank: "1",
    imageURL: {
      large: "http://pics.dmm.co.jp/mono/actjpgs/uehara_ai02.jpg",
      small: "http://pics.dmm.co.jp/mono/actjpgs/thumbnail/uehara_ai02.jpg",
    },
    listURL: {
      digital: "https://al.dmm.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2Fdigital%2Fvideoa%2F-%2Flist%2F%3D%2Farticle%3Dactress%2Fid%3D1011199%2F&af_id=withruit-990&ch=api",
      mono: "https://al.dmm.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2Fmono%2Fdvd%2F-%2Flist%2F%3D%2Farticle%3Dactress%2Fid%3D1011199%2F&af_id=withruit-990&ch=api",
      monthly: "https://al.dmm.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2Fmonthly%2Fpremium%2F-%2Flist%2F%3D%2Farticle%3Dactress%2Fid%3D1011199%2F&af_id=withruit-990&ch=api",
      ppm: "https://al.dmm.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2Fppm%2Fvideo%2F-%2Flist%2F%3D%2Farticle%3Dactress%2Fid%3D1011199%2F&af_id=withruit-990&ch=api",
      rental: "https://al.dmm.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2Frental%2Fppr%2F-%2Flist%2F%3D%2Farticle%3Dactress%2Fid%3D1011199%2F&af_id=withruit-990&ch=api",
    },
    name: "上原亜衣",
    ruby: "うえはらあい",
    services: [
      {
        URL: "https://www.dmm.co.jp/digital/videoa/-/detail/=/cid=h_175dxhk00001/",
        URLsp: "https://www.dmm.co.jp/digital/videoa/-/detail/=/cid=h_175dxhk00001/",
        affiliateURL: "https://al.dmm.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2Fdigital%2Fvideoa%2F-%2Fdetail%2F%3D%2Fcid%3Dh_175dxhk00001%2F&af_id=withruit-990&ch=api",
        affiliateURLsp: "https://al.dmm.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2Fdigital%2Fvideoa%2F-%2Fdetail%2F%3D%2Fcid%3Dh_175dxhk00001%2F&af_id=withruit-990&ch=api",
        content_id: "h_175dxhk00001",
        product_id: '1',
        review: {
          count: 1,
          average: 1
        },
        sampleMovieURL: {
          size_476_306: "https://hoge.com",
          size_560_360: "https://hoge.com"
        },
        imageURL: {
          large: "https://pics.dmm.co.jp/digital/video/h_175dxhk00001/h_175dxhk00001pl.jpg",
          list: "https://pics.dmm.co.jp/digital/video/h_175dxhk00001/h_175dxhk00001pt.jpg",
          small: "https://pics.dmm.co.jp/digital/video/h_175dxhk00001/h_175dxhk00001ps.jpg",
        },
        iteminfo: {
          genre: [],
        },
        title: 'hoge',
        prices: {
          deliveries: {
            delivery: [
              {
                price: "300",
                type: "stream",
              },
              {
                price: "980",
                type: "download",
              },
              {
                price: "1270",
                type: "hd",
              },
              {
                price: "980",
                type: "androiddl",
              },
              {
                price: "980",
                type: "iosdl",
              }
            ]
          }
        }
      }
    ]
  }
]
